"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LineStyle;
(function (LineStyle) {
    LineStyle["SOLID"] = "solid";
    LineStyle["DASHED"] = "dashed";
})(LineStyle = exports.LineStyle || (exports.LineStyle = {}));
var DeltaLabelStyle;
(function (DeltaLabelStyle) {
    DeltaLabelStyle["TARGET_VALUE"] = "target-value";
    DeltaLabelStyle["HISTORICAL_DELTA"] = "historical-delta";
})(DeltaLabelStyle = exports.DeltaLabelStyle || (exports.DeltaLabelStyle = {}));
var LineLabelStyle;
(function (LineLabelStyle) {
    LineLabelStyle["LATEST_VALUE"] = "latest-value";
    LineLabelStyle["NONE"] = "none";
})(LineLabelStyle = exports.LineLabelStyle || (exports.LineLabelStyle = {}));
//# sourceMappingURL=models.js.map